/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * Praetoid Dashboard API
 * OpenAPI spec version: 1.0
 */
import * as zod from 'zod';

export const ApiToken = zod
	.object({
		active: zod.boolean().describe('Whether the API key is active'),
		environment_id: zod.string().describe('Environment ID this key belongs to'),
		id: zod.string().describe('API key ID'),
		inserted_at: zod.iso.datetime({ offset: true }).describe('Creation timestamp'),
		key: zod
			.string()
			.nullable()
			.describe('Full API key; present only for sandbox-environment keys'),
		key_type: zod.enum(['test', 'live']),
		name: zod.string().describe('API key name'),
		public_id: zod.string().describe('Public id of the API key')
	})
	.describe('API token schema for display');

export type ApiToken = zod.input<typeof ApiToken>;
export type ApiTokenOutput = zod.output<typeof ApiToken>;
